import { ScreenTypes } from '../services/types/screen';

export const ScreenTypeOptions = [
  { screenType: '', text: 'Home APP' },
  { screenType: 'marisa-servicos-mobile', text: 'M Serviços (APP)' },
  { screenType: 'marisa-servicos-web', text: 'M Serviços (Web)' },
  { screenType: 'landing-page', text: 'Landing Page' },
] as const;

const getScreenTypeText = (type: ScreenTypes) => {
  const result = ScreenTypeOptions.find((item) => item.screenType === type);
  if (result) return result.text;
  return 'Home APP';
};

export default getScreenTypeText;
